import { useFlags } from '@axo/shared/services/feature-flags';
import { features } from '@axo/shared/services/feature-flags/config/features.config';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Children, cloneElement, ComponentProps, ReactNode } from 'react';
import styles from './Consent.module.scss';
import { Marketing } from './Marketing';
import { TermsAndConditions } from './TermsAndConditions';
import { CreditCheck } from './TermsAndConditions/CreditCheck';
import { useTerms } from './hooks/useTerms';

type ConsentProps = {
  children: ReactNode;
  showMarketingConsent?: boolean;
  gap?: ComponentProps<typeof Stack>['gap'];
};

export type InnerConsentProps = {
  visible?: boolean;
  external?: boolean;

  // TODO: remove after Sweden is using the new consent config
  terms?: any;
  version?: string;
};

// TODO: remove children mapping, its only for evaluating the external flag once
const ConsentRoot = ({
  gap = 'xs',
  children,
  showMarketingConsent = true,
}: ConsentProps) => {
  const { 'use-consent-service-content': useConsentServiceContent } =
    useFlags(features);

  // TODO: move the hook call inside TermsAndConditions component after Sweden is using the new consent config
  const { data: terms, version } = useTerms(useConsentServiceContent);

  return (
    <Stack
      gap={gap}
      className={styles.consent}
      data-hidden={!showMarketingConsent}
    >
      {Children.map(children, (child: any) =>
        cloneElement(child, {
          visible: showMarketingConsent,
          external: useConsentServiceContent,
          terms,
          version,
        })
      )}
    </Stack>
  );
};

export const Consent = Object.assign(ConsentRoot, {
  TermsAndConditions,
  Marketing,
  Credit: CreditCheck,
});
